import script from "./DinheiroCofre.vue?vue&type=script&setup=true&lang=js"
export * from "./DinheiroCofre.vue?vue&type=script&setup=true&lang=js"

import "./DinheiroCofre.vue?vue&type=style&index=0&id=575c49df&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-575c49df"]])

export default __exports__